import { render, staticRenderFns } from "./pj-table.vue?vue&type=template&id=dbce6938&scoped=true"
import script from "./pj-table.vue?vue&type=script&lang=js"
export * from "./pj-table.vue?vue&type=script&lang=js"
import style0 from "./pj-table.vue?vue&type=style&index=0&id=dbce6938&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbce6938",
  null
  
)

export default component.exports